import _ from "lodash";
import moment from "moment";
import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

function SEO({ seo, url = "https://trend.io", author, publishedAt }) {
  const meta = [
    {
      name: `description`,
      content: _.get(seo, "description"),
    },
    {
      property: `og:title`,
      content:
        _.get(seo, "ogTitle") ||
        _.get(seo, "title") ||
        "Micro-Influencer Marketing Platform and Network",
    },
    {
      property: `og:url`,
      content: url,
    },
    {
      property: `og:description`,
      content: _.get(seo, "ogDescription") || _.get(seo, "description"),
    },
    {
      property: `og:type`,
      content: "website",
    },
    {
      property: `og:image`,
      content: _.get(seo, "ogImage.fixed.src") || _.get(seo, "image"),
    },
    {
      property: `og:image:height`,
      content: _.get(seo, "ogImage.fixed.height"),
    },
    {
      property: `og:image:width`,
      content: _.get(seo, "ogImage.fixed.width"),
    },
    {
      name: `twitter:card`,
      content: `summary_large_image`,
    },
    {
      name: `twitter:title`,
      content: _.get(seo, "twitterTitle") || _.get(seo, "title"),
    },
    {
      name: `twitter:description`,
      content: _.get(seo, "twitterDescription") || _.get(seo, "description"),
    },
    {
      name: `twitter:image`,
      content: _.get(seo, "twitterImage.fixed.src"),
    },
  ];

  if (author) {
    meta.push({
      name: "author",
      content: author,
    });
  }

  if (publishedAt) {
    meta.push({
      itemprop: "datePublished",
      content: moment(publishedAt).format(),
    });
  }

  if (publishedAt) {
    meta.push({
      property: "article:published_time",
      content: moment(publishedAt).format(),
    });
  }

  return (
    <Helmet
      htmlAttributes={{
        lang: "en",
      }}
      title={_.get(
        seo,
        "title",
        "Micro-Influencer Marketing Platform and Network"
      )}
      titleTemplate={`%s | Trend`}
      meta={meta}
      link={[{ rel: "canonical", href: url.replace(/\/$/, "") }]}
    />
  );
}

export default SEO;
